import { Injectable } from '@angular/core';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { Store } from '@ngrx/store';

import { SwitchAttrsActions, SwitchAttrsFacade } from '@mode/switch-views/contract';
import { DomainAppState } from '../switch-view-domain.types';

@Injectable()
export class SwitchAttrsService implements SwitchAttrsFacade {
  constructor(private store: Store<DomainAppState>) {}

  public createSwitchAttr(attr: FlamingoTypes.ModeCalc, token: string): void {
    this.store.dispatch(SwitchAttrsActions.createSwitchViewAttr({ attr, token }));
  }

  public createSwitchAttrFromDataView(attr: FlamingoTypes.ModeCalc, token: string): void {
    this.store.dispatch(SwitchAttrsActions.createSwitchViewAttrFromDataview({ attr, token }));
  }

  public updateSwitchAttr(
    attr: FlamingoTypes.ModeCalc,
    token: string,
    prevAttr: FlamingoTypes.ModeCalc,
    queryToken: string
  ): void {
    this.store.dispatch(SwitchAttrsActions.updateSwitchViewAttr({ attr, token, prevAttr, queryToken }));
  }

  public updateSwitchAttrFromDataView(
    attr: FlamingoTypes.ModeCalc,
    token: string,
    prevAttr: FlamingoTypes.ModeCalc,
    queryToken: string
  ): void {
    this.store.dispatch(SwitchAttrsActions.updateSwitchViewAttrFromDataView({ attr, token, prevAttr, queryToken }));
  }

  public deleteSwitchAttr(attr: FlamingoTypes.ModeCalc, token: string, queryToken: string): void {
    this.store.dispatch(SwitchAttrsActions.deleteSwitchViewAttr({ attr, token, queryToken }));
  }

  public makeOriginalAttrs(): void {
    this.store.dispatch(SwitchAttrsActions.makeOriginalAttrs());
  }

  public restoreOriginalAttrs(): void {
    this.store.dispatch(SwitchAttrsActions.restoreOriginalAttrs());
  }
}
